import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { dispatchActiveLanguage } from './LanguageReducer';

import { LanguageToggleProps, Languages } from './LanguageToggleTypes';
import { capitalizeFirstLetter } from '../../helpers/stringUtils';

const classNames = require('classnames');

const LanguageToggle: React.FC<LanguageToggleProps> = ({ context, dealerLanguages, recipientLanguage, dispatchLanguage, features, translate, languageStore }) => {
    const [activeLanguage, setActiveLanguage] = useState('');
    const [disableToggle, setDisableToggle] = useState(false);

    useEffect(() => {
        setActiveLanguage(languageStore.activeLanguage ? languageStore.activeLanguage : recipientLanguage);
        features.includes(201) && setDisableToggle(true);
    }, []);

    useEffect(() => {
        dispatchLanguage(activeLanguage);
    }, [activeLanguage]);

    const handleSelect = e => {
        setActiveLanguage(e.target.value);
    };
    // this one will render the radio language selector for groups of less then 3 languages
    const renderRadioGroup = () => {
        return(
            <div className="language_selector_radio">
                {dealerLanguages.map( language => {
                    const radioClass = classNames({
                        language__radio__item: true,
                        language__radio__selected: language === activeLanguage
                    });

                    return(
                        <label className={`language__radio__label ${radioClass}`} htmlFor={language + '__option'}>
                                <input
                                    className="language__radio__button"
                                    type="radio"
                                    onChange={handleSelect}
                                    id={language + '__option'}
                                    name="language__radio__select"
                                    value={language}
                                    checked={language === activeLanguage}
                                    disabled={disableToggle}
                                />{capitalizeFirstLetter(translate(Languages[language]))}
                        </label>
                    );
                })}
            </div>
        );
    };

    // this one will render the dropdown selector for groups of 4 or more languages
    const renderDropdownGroup = () => {
        return(
            <div className="language_dropdown_container">
                <select className="language_dropdown_select" onChange={handleSelect} defaultValue={activeLanguage} disabled={disableToggle}>
                    {dealerLanguages.map( language => {
                        return (
                            <option
                                value={language}
                                key={language}
                                >
                                    {capitalizeFirstLetter(translate((Languages[language])))}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    };
// this one renders toggles based on the amount of languages, if 1 language than no toggle ui but finctionality should stay.
    const renderSelector = () => {
        if (dealerLanguages.length <= 1) {
            return;
        }

        if (dealerLanguages.length <= 3) {
            return renderRadioGroup();
        }

        return renderDropdownGroup();
    };

    return (
        <div className="language_toggle">
            <div className={context}>
                { renderSelector() }
            </div>
        </div>
    );
};

const mapStateToProps = ({ languageStore }) => ({
    languageStore
});

const mapDispatchToProps = dispatch => ({
    dispatchLanguage: language => dispatch(dispatchActiveLanguage(language)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageToggle);



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/LanguageToggleComponent.tsx